import React, { FC, ReactNode } from "react";
import styles from "./PointList.module.scss";

export const PointList: FC<{
  children?: ReactNode;
}> = ({ children }) => {
  return <ul className={styles.base}>{children}</ul>;
};
